module.exports = __webpack_public_path__ + "442a4712e97f7f86e6ceff31a68efcaf.pdf";